import { Controller } from "@hotwired/stimulus";
import { transformToHourFormat } from "@/utilities/timing_helpers";

export default class extends Controller {
  static targets = ["timer"]
  static values = {
    isShortTimer: {
      type: Boolean,
      default: false,
    }
  }

  connect() {
    this.intervalId = null;
    this.elapsedTime = 0;
  }

  disconnect() {
    if (this.intervalId) {
      this.#clearInterval();
    }
  }

  launch(event) {
    if (event.type === "recording") {
      this.timerTarget.classList.remove("invisible");
      this.timerTarget.classList.remove("hidden");
    }
    this.intervalId = setInterval(() => {
      this.elapsedTime += 1;
      this.timerTarget.textContent = transformToHourFormat(this.elapsedTime, { shortFormat: this.isShortTimerValue });
    }, 1000)
  }

  freeze() {
    this.#clearInterval();
  }

  handleRecording(event) {
    if (event.detail.status === "started") {
      this.launch(event)
    } else {
      this.freeze();
    }
  }

  #clearInterval() {
    clearInterval(this.intervalId);
  }
}
